/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Zm1.5 0c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0s12 5.3726 12 12Zm-11.5342 3.739h-1.4472l-.0381.0095c0-.6474.1237-1.2378.3808-1.771.2571-.5332.5618-.9712.9236-1.3044.3618-.3333.7236-.657 1.0759-.9617a5.4329 5.4329 0 0 0 .9141-1.0188c.2571-.3713.3809-.7712.3809-1.1997 0-.7331-.2476-1.333-.7332-1.79-.4856-.457-1.1426-.6856-1.9709-.6856-.8284 0-1.514.238-2.0567.7237-.5427.4856-.914 1.133-1.1045 1.9519l-1.3901-.4094c.219-1.057.7236-1.933 1.5044-2.628.7807-.695 1.8091-1.0473 3.0754-1.0473 1.2378 0 2.2566.3522 3.0469 1.0664.7903.714 1.1902 1.6281 1.1902 2.7422 0 .5712-.1333 1.0949-.3904 1.5615-.2571.4665-.5713.8664-.9426 1.1902-.3714.3237-.7332.6474-1.095.9711a4.7592 4.7592 0 0 0-.9331 1.1426c-.2571.438-.3904.9236-.3904 1.4568Zm0 3.5896c-.2095.2095-.4665.3142-.7807.3142-.3143 0-.5713-.1047-.7808-.3142-.2095-.2095-.3142-.4665-.3142-.7807 0-.2952.1047-.5428.3142-.7427.2095-.2.4665-.3047.7808-.3047.3142 0 .5712.1047.7807.3047.2095.1999.3142.4475.3142.7427 0 .3142-.1047.5712-.3142.7807Z"
    clipRule="evenodd"
  />,
  'Question'
);
